import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import appConstants from "../constants/appConstants";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Layout from "../components/Layout";
import axios from "axios";
import { Tab, Nav, Form, Button, Modal, Card, Table } from "react-bootstrap";
import "./page.css";


const getAuthToken = () => localStorage.getItem("authToken");


const StudentSummary = () => {
  const navigate = useNavigate();
    const { studentId } = useParams();
    const [student, setStudent] = useState(null);
    const [attendance, setAttendance] = useState([]);
    const [notes, setNotes] = useState("");
    const [testMarks, setTestMarks] = useState({});
    const [loading, setLoading] = useState(true);
    const [loadingAttendance, setLoadingAttendance] = useState(true);
    const [activeTab, setActiveTab] = useState("attendance");
    const [attendanceMonth, setAttendanceMonth] = useState(new Date().getMonth() + 1);
    const [notesMonth, setNotesMonth] = useState(new Date().getMonth() + 1);
    const [showModal, setShowModal] = useState(false);
    const [currentNote, setCurrentNote] = useState("");
    const [currentNoteId, setCurrentNoteId] = useState(null);
    const [noteDate, setNoteDate] = useState("");
    const [transactions, setTransactions] = useState([]);
    const [selectedNote, setSelectedNote] = useState(null);
    const [showNoteModal, setShowNoteModal] = useState(false);
    const scrollRefs = useRef({});
    const [feeData, setFeeData] = useState(
      {
        prevBalance : 0,
        thisYearFee : 0,
        totalPaid : 0,
        totalReturn : 0,
      }
    );
    const [loadingExamMarks, setLoadingExamMarks] = useState(false);
    const [terms, setTerms] = useState([]);
    const [subjects, setSubjects] = useState([]);

    const months = Array.from({ length: 12 }, (_, i) =>
      new Date(2025, i).toLocaleString("default", { month: "long" })
    );

    useEffect(() => {
      // Scroll each subject container to the right-most position
      Object.values(scrollRefs.current).forEach(container => {
        if (container) {
          container.scrollLeft = container.scrollWidth;
        }
      });
    }, [testMarks]); // whenever marks load/update

    useEffect(() => {
  if (activeTab === "examMarks" && studentId) {
    fetchExamMarks(studentId);
  }
}, [activeTab, studentId]);

    useEffect(() => {
      const totalPaid = transactions
        .filter(txn => txn.txn_type === "C")
        .reduce((sum, txn) => sum + parseFloat(txn.amount), 0);
    
      const totalReturn = transactions
        .filter(txn => txn.txn_type === "D")
        .reduce((sum, txn) => sum + parseFloat(txn.amount), 0);

    
      
      setFeeData(prevState => ({
        ...prevState,
        totalPaid,
        totalReturn
      }));
    }, [transactions]);
    

    useEffect(() => {
      fetchStudentData();
      loadAttendance(attendanceMonth);
      loadNotes();
      loadFeeDetails();
      loadMarks();
    }, [studentId]);
  
    useEffect(() => {
      loadAttendance(attendanceMonth);
    }, [attendanceMonth]);
  
    const fetchStudentData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${appConstants.API_ROOT_URL}student-summary`,
          { student_id: studentId },
          { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
        );
  
        if (response.data.status === "success") {
          setStudent(response.data.student);
          //setAttendance(response.data.attendance);
          setNotes(response.data.notes || "");
        }
      } catch (error) {
        console.error("Error fetching student data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    
    
    const fetchExamMarks = async (studentId) => {
  setLoadingExamMarks(true);
  try {
    const token = localStorage.getItem("authToken");
    const res = await axios.get(
      `${appConstants.API_ROOT_URL}get-student-term-exam-marks?student_id=${studentId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data.status === "success") {
      const { terms, subjects } = res.data;

      const processedSubjects = [];
      const termTotals = {}; // For calculating total row

      // Initialize totals
      terms.forEach((term) => {
        termTotals[term] = { marks_obtained: 0, max_mark: 0 };
      });

      // Process each subject
      subjects.forEach((subject) => {
        const formattedMarks = {};
        terms.forEach((term) => {
          const termMark = subject.marks[term];
          if (termMark) {
            const { marks_obtained, max_mark } = termMark;
            formattedMarks[term] = `${marks_obtained} / ${max_mark}`;

            // Accumulate totals
            const mark = parseFloat(marks_obtained);
            const max = parseFloat(max_mark);
            if (!isNaN(mark)) termTotals[term].marks_obtained += mark;
            if (!isNaN(max)) termTotals[term].max_mark += max;
          } else {
            formattedMarks[term] = "-";
          }
        });

        processedSubjects.push({
          subject_name: subject.subject_name,
          marks: formattedMarks,
        });
      });

      // Add Total row
      const totalRow = {
        subject_name: "Total",
        marks: {},
      };

      terms.forEach((term) => {
        const total = termTotals[term];
        if (total.max_mark > 0) {
          totalRow.marks[term] = `${total.marks_obtained} / ${total.max_mark}`;
        } else {
          totalRow.marks[term] = "-";
        }
      });

      processedSubjects.push(totalRow); // Add at the end

      setTerms(terms);
      setSubjects(processedSubjects);
    } else {
      alert(res.data.message || "Failed to load exam marks");
    }
  } catch (error) {
    console.error("Error fetching exam marks:", error);
    alert("Error fetching exam marks");
  } finally {
    setLoadingExamMarks(false);
  }
};





    const handleDeleteNote = async (note) => {
      if (!window.confirm("Are you sure you want to delete this Note?")) return;
      if(!note){
        return;
      }

      if (!studentId) return;
        const token = getAuthToken();
        if (!token) {
            alert("Unauthorized! Please log in.");
            return;
        }
    
        try {
            await axios.post(
                `${appConstants.API_ROOT_URL}create-student-note`,
                {
                    student_id: studentId,
                    note: "",
                    date: note.note_date
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            loadNotes();
            setShowModal(false);
        } catch (error) {
            console.error("Failed to save note", error);
            alert("Error saving note");
        }

    }

    const handleEditNote = (note) => {
        setCurrentNoteId(note.id);
        setCurrentNote(note.note);
        setNoteDate(note.note_date);
        setShowModal(true);
    };

    const handleAddNote = () => {
        setCurrentNote("");
        setCurrentNoteId(null);
        setNoteDate("");
        setShowModal(true);
    };
    
    const handleCalendarAddNote = (date) => {
        setCurrentNote("");
        setCurrentNoteId(null);
        setNoteDate(date);
        setShowModal(true);
    };

    const loadAttendance = async (month) => {
      try {
        const data = await fetchAttendance(studentId, month);
        setAttendance(data);
      } catch (error) {
        console.error("Error fetching attendance:", error);
      }
    };

    const loadNotes = async () => {
        try {
            /*const year = new Date().getFullYear(); // Get current year
            const month = notesMonth.toString().padStart(2, "0"); // Ensure two-digit month
            const date = `${year}-${month}-01`; // First day of the selected month (YYYY-MM-DD)
*/
            
          const response = await axios.post(
            `${appConstants.API_ROOT_URL}get-one-student-notes`,
            { student_id: studentId },
            { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
          );
          setNotes(response.data.notes || []);
        } catch (error) {
          console.error("Error fetching notes:", error);
        }
      };
  
      const loadMarks = async () => {
        try {
            
          const response = await axios.post(
            `${appConstants.API_ROOT_URL}get-student-test-marks`,
            { student_id: studentId },
            { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
          );
          
          if (response.data.status === "success") {
            const grouped = {};
    
            response.data.data.forEach(mark => {
              const subject = mark.subject_name;
    
              if (!grouped[subject]) {
                grouped[subject] = [];
              }
    
              grouped[subject].push(mark);
            });
    
            setTestMarks(grouped);
          } else {
            setTestMarks({});
          }

        } catch (error) {
          console.error("Error fetching notes:", error);
        }
      };

      const loadFeeDetails = async () => {
        try {
          const response = await axios.post(
            `${appConstants.API_ROOT_URL}get-fee-details`,
            { student_id: studentId },
            { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
          );
          setTransactions(response.data.data.transactions);
          setFeeData({...feeData, prevBalance: response.data.data.prevBalance, thisYearFee: response.data.data.thisYearFee});
        } catch (error) {
          console.error("Error fetching notes:", error);
        }
      };

    const fetchAttendance = async (studentId, month) => {
      setLoadingAttendance(true);
      try {
        const year = new Date().getFullYear(); // Get current year
        const month = attendanceMonth.toString().padStart(2, "0"); // Ensure two-digit month
        const date = `${year}-${month}-01`; // First day of the selected month (YYYY-MM-DD)

        const response = await axios.post(
            `${appConstants.API_ROOT_URL}get-student-attendance`,
            { student_id: studentId, date },  // JSON payload
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`
              }
            }
          );
          

          
  
        return response.data.attendance || {};
      } catch (error) {
        console.error("Error fetching attendance:", error);
        return {};
      }
      finally{
        setLoadingAttendance(false);
      }
    };
  
    const changeMonth = (type, direction) => {
      if (type === "attendance") {
        setAttendanceMonth((prev) =>
          prev + direction < 1 ? 12 : prev + direction > 12 ? 1 : prev + direction
        );
      } else {
        setNotesMonth((prev) =>
          prev + direction < 1 ? 12 : prev + direction > 12 ? 1 : prev + direction
        );
      }
    };
  

      const handleSaveNote = async () => {
        if (!studentId) return;
        const token = getAuthToken();
        if (!token) {
            alert("Unauthorized! Please log in.");
            return;
        }
    
        try {
            await axios.post(
                `${appConstants.API_ROOT_URL}create-student-note`,
                {
                    student_id: studentId,
                    note: currentNote,
                    date: noteDate
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            loadNotes();
            setShowModal(false);
        } catch (error) {
            console.error("Failed to save note", error);
            alert("Error saving note");
        }
    };
/*
    const renderAttendanceCalendar = () => {
        const year = new Date().getFullYear();
        const month = attendanceMonth;
        const totalDays = new Date(year, month, 0).getDate();
        const firstDay = new Date(year, month - 1, 1).getDay(); // 0 = Sunday, 6 = Saturday
    
        const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const calendarCells = [];
    
        // Empty slots before first day
        for (let i = 0; i < firstDay; i++) {
            calendarCells.push(<div key={`empty-${i}`} className="p-2 border text-center" style={{ width: "40px", height: "40px" }}></div>);
        }
    
        // Actual attendance days
        for (let day = 1; day <= totalDays; day++) {
            const data = attendance[day] || { status: "N" }; // Default "N" for missing data
    
            calendarCells.push(
                <div
                    key={day}
                    className={`p-2 border text-center ${
                        data.status === "A" ? "bg-danger text-white" :
                        data.status === "P" ? "bg-success text-white" :
                        "bg-light"
                    }`}
                    style={{ width: "40px", height: "40px" }}
                >
                    {day}
                </div>
            );
        }
    
        return (
            <div className="d-flex flex-column align-items-center">
                <div className="d-grid" style={{ gridTemplateColumns: "repeat(7, 40px)", textAlign: "center" }}>
                    {daysOfWeek.map((day) => (
                        <div key={day} className="p-2 border fw-bold" style={{ width: "40px", textAlign: "center" }}>
                            {day}
                        </div>
                    ))}
                </div>
                <div className="d-grid border p-2" style={{ gridTemplateColumns: "repeat(7, 40px)", textAlign: "center" }}>
                    {calendarCells}
                </div>
            </div>
        );
    };
        */

    const renderAttendanceCalendar = () => {
      const year = new Date().getFullYear();
      const month = attendanceMonth;
      const totalDays = new Date(year, month, 0).getDate();
      const firstDay = new Date(year, month - 1, 1).getDay(); // 0 = Sunday
  
      const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const calendarCells = [];
  
      const today = new Date();
      const isToday = (day) =>
          today.getDate() === day &&
          today.getMonth() + 1 === month &&
          today.getFullYear() === year;
  
        const handleDayClick = (day) => {
          
          
          const date = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
          
          // Find the note with matching date
          const note = notes.find(n => n.note_date === date);
          
          setSelectedNote(note ? { ...note, date } : { id: null, note: "", date });
          if(note){
            handleEditNote(note);
          }
          else{
            handleCalendarAddNote(date);
          }
      };
      
  
      // Empty cells for offset
      for (let i = 0; i < firstDay; i++) {
          calendarCells.push(
              <div key={`empty-${i}`} className="p-2 border" style={{ width: "40px", height: "40px" }} />
          );
      }
  
      // Calendar days
      for (let day = 1; day <= totalDays; day++) {
          const dayData = attendance[day] || { status: "N" };
          const dateStr = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
          const note = notes.find(n => n.note_date === dateStr);
          const hasNote = !!note;

          const tooltip = `${dayData.status === "P" ? "Present" : dayData.status === "A" ? "Absent" : "No Data"}`
              + (hasNote ? `\nNote: ${note.note.slice(0, 30)}...` : "");
  
          let bgClass = "bg-light";
          if (dayData.status === "P") bgClass = "bg-success text-white";
          else if (dayData.status === "A") bgClass = "bg-danger text-white";
  
          const extraClass = isToday(day) ? "border border-dark border-2" : "";
          
          calendarCells.push(
            <div
                key={day}
                onDoubleClick={() => handleDayClick(day)}
                className={`p-2 border text-center cursor-pointer ${bgClass} ${extraClass}`}
                style={{ width: "40px", height: "40px", cursor: "pointer", lineHeight: "1" }}
                title={tooltip}
            >
                <div>{day}</div>
                {hasNote && (
                <span
                    style={{
                        display: "inline-block",
                        width: "20px",
                        height: "4px",
                        borderRadius: "8px",
                        backgroundColor: "#ff9292",
                        marginLeft: "0px",
                        marginBottom: "1px"
                    }}
                ></span>
            )}

            </div>
            
          );
      }
  
      return (
          <div className="d-flex flex-column align-items-center">
              <div className="d-grid" style={{ gridTemplateColumns: "repeat(7, 40px)", textAlign: "center" }}>
                  {daysOfWeek.map((day) => (
                      <div key={day} className="p-2 border fw-bold bg-light" style={{ width: "40px" }}>
                          {day}
                      </div>
                  ))}
              </div>
              <div className="d-grid border p-2" style={{ gridTemplateColumns: "repeat(7, 40px)" }}>
                  {calendarCells}
              </div>
          </div>
      );
  };
  
  

    const handleViewProfile = (student_id) => {
      navigate(`/student-view/${student_id}`)
    }

    
    const handlePrintSummary = (student_id) => {
      navigate(`/student-summary-printable/${student_id}`)
    }


  if (loading) return (
  <Layout>
      <div className="text-center mt-5">Loading...</div>
    </Layout>
  );

  if (!student) return (
  <Layout>
      <div className="text-center mt-5">Student not found</div>
  </Layout>
  );


  return (
    <Layout>
      <div className="row">
        {/* Student Basic Details (1/4 width) */}
        <div className="col-md-3 text-center">
          {student.status === 'Suspend' && (
              <div className="bg-danger text-white text-center py-1 mb-2 w-100" style={{ borderRadius: '0' }}>
                Suspended
              </div>
            )}


        {/* Student Photo */}
        <div className="d-flex justify-content-center">
        
            <img
                src={student.photo ? `${appConstants.API_ROOT_URL}uploads/students/${student.photo}` : `${appConstants.API_ROOT_URL}uploads/students/blank.png`}
                alt="Student"
                className="img-fluid mb-2 shadow"
                style={{ width: "140px", height: "180px", objectFit: "cover", borderRadius: "12px" }}
            />
        </div>


        {/* Student Name & ID */}
        <h5 className="mt-2 fw-bold">{student.name}</h5>
        <h6 className="text-muted">{student.admission_no ? student.admission_no : `Appl: ${student.application_no}`}</h6>

        {/* Batch Details */}
        <p className="mb-2"><i className="fas fa-user-graduate text-primary"></i> {student.batch_detail}</p>

        {/* Mobile Numbers Section */}
        {student.mobile && student.mobile.split(",").map((num, index) => (
        <div key={index} className="d-flex justify-content-center align-items-center gap-2 mb-2">
            <a href={`tel:${num.trim()}`} 
            className="btn btn-primary btn-sm d-flex align-items-center justify-content-start px-3"
            style={{ minWidth: "140px", height: "32px" }}>
            <i className="fas fa-phone me-2"></i> {num.trim()}
            </a>
            <a href={`https://wa.me/${num.trim()}`} target="_blank" rel="noopener noreferrer" 
            className="btn btn-success btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "32px", height: "32px" }}>
            <i className="fab fa-whatsapp"></i>
            </a>
        </div>
        ))}


        {/* Address in Styled Box */}
        <div className="border rounded p-2 text-muted bg-light small mx-auto" style={{ maxWidth: "180px" }}>
            <i className="fas fa-map-marker-alt text-danger"></i> {student.address}
        </div>

        {/* View Full Profile Button */}
        <a href="" onClick={() => {handleViewProfile(student.id)}} className="btn btn-info mt-3 d-flex align-items-center justify-content-center mx-auto"
            style={{ width: "80%", maxWidth: "200px" }}>
            <i className="fas fa-external-link-alt me-2"></i> View Profile
        </a>

        {/* Print Summary */}
        <a href="" onClick={() => {handlePrintSummary(student.id)}} className="btn btn-info mt-3 d-flex align-items-center justify-content-center mx-auto"
            style={{ width: "80%", maxWidth: "200px" }}>
            <i className="fas fa-external-link-alt me-2"></i> Print Summary
        </a>
        </div>


  













        {/* Main Content (1/2 width) - Attendance, Notes */}
        <div className="col-md-6">
           
      <Tab.Container activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <Nav.Link eventKey="attendance"><i className="fas fa-calendar-alt"></i> Attendance</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="notes"><i className="fas fa-sticky-note"></i> Notes</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="marks"><i className="fas fa-chart-bar"></i> Test Marks</Nav.Link>
          </Nav.Item>
          <Nav.Item>
  <Nav.Link eventKey="examMarks"><i className="fas fa-table"></i> Exam Marks</Nav.Link>
</Nav.Item>

        </Nav>

        <Tab.Content>
          {/* Attendance Tab */}
          <Tab.Pane eventKey="attendance">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <button className="btn btn-outline-secondary btn-sm" onClick={() => changeMonth("attendance", -1)}>
                <i className="fas fa-chevron-left"></i>
              </button>
              <Form.Select
                value={attendanceMonth}
                onChange={(e) => setAttendanceMonth(parseInt(e.target.value))}
                className="w-auto"
              >
                {months.map((month, index) => (
                  <option key={index + 1} value={index + 1}>{month}</option>
                ))}
              </Form.Select>
              <button className="btn btn-outline-secondary btn-sm" onClick={() => changeMonth("attendance", 1)}>
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
            {loadingAttendance ? (
              <>Loading...</>
            ) : (
              
              renderAttendanceCalendar()
              
            )
            }
            

          </Tab.Pane>

          {/* Notes Tab */}
          <Tab.Pane eventKey="notes">
            <Button variant="primary" className="mb-2" onClick={handleAddNote}>
                <i className="fas fa-plus"></i> Add Note
            </Button>
            <ul className="list-group">
                {notes.map((note) => (
                    <li key={note.id} className="list-group-item d-flex justify-content-between align-items-center">
                        <span>{note.note_date}: {note.note}</span>
                        <div>
                        <Button className="me-1" variant="outline-secondary" size="sm" onClick={() => handleEditNote(note)}>
                            <i className="fas fa-edit"></i>
                        </Button>
                        <Button variant="outline-danger" size="sm" onClick={() => handleDeleteNote(note)}>
                            <i className="fas fa-trash"></i>
                        </Button>
                        </div>
                    </li>
                ))}
            </ul>
        </Tab.Pane>


        {/* Marks Tab */}
        <Tab.Pane eventKey="marks">
        {!loading &&
          Object.keys(testMarks).map(subject => (
            <div key={subject} className="mb-3">
              <h6>{subject}</h6>
              <div
                className="test-tile-container"
                ref={el => (scrollRefs.current[subject] = el)}
              >
                {Array.isArray(testMarks[subject]) &&
                  testMarks[subject].map(test => (
                    <div key={test.test_id} className="test-tile">
                      <div><strong>{test.test_name}</strong></div>
                      <div>{test.mark} / {test.total_mark}</div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </Tab.Pane>

        
        

        
        
        <Tab.Pane eventKey="examMarks">
  {loadingExamMarks ? (
    <>Loading Exam Marks...</>
  ) : (
    <Table bordered hover size="sm">
      <thead className="table-light">
        <tr>
          <th>Subject</th>
          {terms.map((term) => (
            <th key={term}>{term}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {subjects.map(({ subject_name, marks }) => (
          <tr key={subject_name}>
            <td>{subject_name}</td>
            {terms.map((term) => (
              <td key={term}>{marks?.[term] ?? "-"}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  )}
</Tab.Pane>









        </Tab.Content>
      </Tab.Container>
    </div>
  






        {/* Right Column (1/4 width) - Fee Details */}
        <div className="col-md-3">
      <h5>
        <i className="fas fa-receipt"></i> Fee Details
      </h5>
      <table className="table table-sm">
        <tbody>
          {/* Previous Balance & This Year Fee */}
          <tr>
            <td><strong>Prev Balance</strong></td>
            <td className="text-end"><strong>{feeData.prevBalance}</strong></td>
          </tr>
          <tr>
            <td><strong>This Year</strong></td>
            <td className="text-end"><strong>{feeData.thisYearFee}</strong></td>
          </tr>
          
          {/* Total Payable */}
          <tr className="table-warning">
            <td><strong>Total Payable</strong></td>
            <td className="text-end"><strong>{feeData.prevBalance + feeData.thisYearFee}</strong></td>
          </tr>

          {/* Transactions */}
          {transactions.map((txn, index) => (
            <tr key={index}>
            <td className={txn.txn_type === "C" ? "text-success" : "text-danger"}>
              {txn.particular}
            </td>
            <td className={`text-end ${txn.txn_type === "C" ? "text-success" : "text-danger"}`}>
              {txn.amount}
            </td>
          </tr>
          
          ))}

          {/* Total Paid & Total Return */}
          {feeData.totalPaid ? (
            <tr className="table-success">
            <td><strong>Total Paid</strong></td>
            <td className="text-end"><strong>{feeData.totalPaid}</strong></td>
          </tr>
          ) : (
            <></>
          )}
          
          {feeData.totalReturn ? (
            <tr className="table-danger">
            <td><strong>Total Return</strong></td>
            <td className="text-end"><strong>{feeData.totalReturn}</strong></td>
          </tr>
          )
        :
        (<></>)}
          

          {/* Final Balance */}
          <tr className="table-info">
            <td><strong>Last Balance</strong></td>
            <td className="text-end"><strong>{feeData.prevBalance + feeData.thisYearFee + feeData.totalReturn - feeData.totalPaid}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>

      </div>
  
      





      <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{currentNoteId ? "Edit Note" : "Add Note"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Date</Form.Label>
                        <Form.Control type="date" value={noteDate} onChange={(e) => setNoteDate(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mt-2">
                        <Form.Label>Note</Form.Label>
                        <Form.Control as="textarea" rows={3} value={currentNote} onChange={(e) => setCurrentNote(e.target.value)} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleSaveNote}>Save Note</Button>
                </Modal.Footer>
            </Modal>
    </Layout>
  );
  
};

export default StudentSummary;
